import {Col, Container, Row} from "react-bootstrap";

export const SiteFooter = () => {
  return (
    <footer className="text-center pt-3 mt-3 pb-3">
      <Container>
        <Row>
          <Col className="text-center text-muted">
            <p>Created by <a href={'https://www.toddljones.com'}>Todd Liebenschutz-Jones</a></p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};